import type { ReactElement } from 'react';
import React from 'react';

import { Box } from '@zillow/constellation';
import { HeroImage } from '@zillow/zrs-cms-messaging';
import { isEmpty } from 'lodash';
import Head from 'next/head';

import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';
import { AllHopsPlacements } from '../../types/genericTypes';
import OnsiteMessageWrapper from '../OnsiteMessageWrapper/OnsiteMessageWrapper';

const OmpHeroImage: React.FC = (): ReactElement => {
    const { onsiteMessages } = useGlobalStoreState();
    if (!isEmpty(onsiteMessages)) {
        return (
            <Box data-testid="hops-hero-image-container">
                <OnsiteMessageWrapper
                    messageData={onsiteMessages}
                    placementName={AllHopsPlacements.HOME_PAGE_HERO_IMAGE}
                    additionalProps={{ Head }}
                />
            </Box>
        );
    }

    return (
        <HeroImage
            mobileImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-sm%401x.jpg"
            mobileImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-sm%402x.jpg"
            mobileWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-sm%401x.webp"
            mobileWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-sm%402x.webp"
            tabletPortraitImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-md%401x.jpg"
            tabletPortraitImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-md%402x.jpg"
            tabletPortraitWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-md%401x.webp"
            tabletPortraitWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-md%402x.webp"
            tabletLandscapeImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-lg%401x.jpg"
            tabletLandscapeImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-lg%402x.jpg"
            tabletLandscapeWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-lg%401x.webp"
            tabletLandscapeWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-lg%402x.webp"
            desktopImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-xl%401x.jpg"
            desktopImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-xl%402x.jpg"
            desktopWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-xl%401x.webp"
            desktopWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/04/homepage-hero-xl%402x.webp"
            Head={Head}
        />
    );
};

export default OmpHeroImage;
